import { ArrowPathIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

type HighlightedButtonProps = React.PropsWithChildren<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> & {
  isSubmitting?: boolean;
};

export function HighlightedButton({
  isSubmitting = false,
  ...props
}: HighlightedButtonProps) {
  return (
    <button
      disabled={isSubmitting}
      {...props}
      className={clsx(
        'bg-primary/50 border border-transparent rounded-md py-2 px-4 text-base font-medium text-primary',
        'focus:outline-none focus:ring-1 focus:ring-offset-0 focus:ring-primary/90 hover:bg-primary hover:text-white transition-all duration-300',
        'disabled:opacity-50 disabled:hover:opacity-30',
        'flex items-center justify-around gap-2',
        props.className,
      )}
    >
      {props.children}
      {isSubmitting && (
        <ArrowPathIcon className="w-4 h-4 animate-spin"></ArrowPathIcon>
      )}
    </button>
  );
}
